<template>
    <div v-show="visible" :class="[namespace(), mdsNS('dialog-wrapper')]">
        <div :class="[mdsNS('overlay'), namespace('overlay')]"></div>
        <div :class="[namespace('container'), ...skinCls]">
            <div
                role="dialog"
                :class="[mdsNS('dialog dialog--active'), namespace('active')]"
                :aria-describedby="id"
            >
                <div
                    v-if="!!title"
                    :class="[namespace('title'), mdsNS('dialog__message')]"
                >
                    {{ title }}
                </div>
                <div :class="mdsNS('dialog__message')" :id="id">
                    {{ message }}
                </div>
                <slot></slot>
                <div
                    v-if="isSingleButton"
                    :class="[
                        mdsNS('dialog__action-buttons'),
                        namespace('single-mode')
                    ]"
                >
                    <button
                        v-if="hasResolve"
                        :class="
                            mdsNS(
                                'button dialog__resolve-button button--primary'
                            )
                        "
                        type="button"
                        @click="click('resolve', resolve)"
                    >
                        {{ resolve.label }}
                    </button>
                </div>
                <template v-else>
                    <div
                        v-if="hasReject || hasCancel || hasResolve"
                        :class="mdsNS('dialog__action-buttons')"
                    >
                        <button
                            v-if="hasReject"
                            :class="mdsNS('button dialog__reject-button')"
                            type="button"
                            @click="click('reject', reject)"
                        >
                            {{ reject.label }}
                        </button>
                        <div
                            v-if="hasCancel && hasResolve"
                            :class="
                                mdsNS('dialog__cancel-resolve-buttons-holder')
                            "
                        >
                            <button
                                :class="mdsNS('button dialog__cancel-button')"
                                type="button"
                                @click="click('cancel', cancel)"
                            >
                                {{ cancel.label }}
                            </button>
                            <button
                                :class="
                                    mdsNS(
                                        'button dialog__resolve-button button--primary'
                                    )
                                "
                                type="button"
                                :disabled="resolve.isDisabled"
                                @click="click('resolve', resolve)"
                            >
                                {{ resolve.label }}
                            </button>
                        </div>
                    </div>
                </template>

                <div
                    :class="[mdsNS('form__field-group'), namespace('checkbox')]"
                    v-if="hasCheckbox"
                >
                    <label
                        :class="mdsNS('form__checkbox')"
                        for="dialog-checkbox"
                    >
                        <input
                            id="dialog-checkbox"
                            type="checkbox"
                            :class="mdsNS('form__checkbox-input')"
                            v-model="checked"
                        />
                        <span :class="mdsNS('form__checkbox-visible-wrap')">
                            <span :class="mdsNS('form__checkbox-visual')">
                                <svg
                                    :class="
                                        mdsNS(
                                            'icon form__checkbox-checked-icon'
                                        )
                                    "
                                    aria-hidden="true"
                                >
                                    <use xlink:href="#check--s"></use>
                                </svg>
                                <svg
                                    :class="
                                        mdsNS(
                                            'icon form__checkbox-indeterminate-icon'
                                        )
                                    "
                                    aria-hidden="true"
                                >
                                    <use xlink:href="#minus--s"></use>
                                </svg>
                            </span>
                            <span :class="mdsNS('form__checkbox-text')"
                                >{{ checkbox.label }}
                            </span>
                        </span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-dialog',
    mixins: [mixins],
    props: {
        message: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: false
        },
        mode: {
            // number of buttons
            type: String,
            required: false,
            default: 'mutiple'
        },
        reject: {
            type: Object,
            default() {
                return {};
            }
        },
        cancel: {
            type: Object,
            default() {
                return {};
            }
        },
        resolve: {
            type: Object,
            default() {
                return {};
            }
        },
        checkbox: {
            type: Object,
            default() {
                return {};
            }
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            id: utils.guid(),
            checked: false
        };
    },
    computed: {
        skinCls() {
            const cls = [];
            if (this.skin) {
                cls.push(
                    this.mdsNS(`container--${utils.getSkinSuffix(this.skin)}`)
                );
                cls.push(
                    this.namespace(
                        `container--${utils.getSkinSuffix(this.skin)}`
                    )
                );
            }
            return cls;
        },
        hasReject() {
            return !utils.isEmptyObject(this.reject);
        },
        hasCancel() {
            return !utils.isEmptyObject(this.cancel);
        },
        hasResolve() {
            return !utils.isEmptyObject(this.resolve);
        },
        hasCheckbox() {
            return !utils.isEmptyObject(this.checkbox);
        },
        isSingleButton() {
            return this.mode === 'single';
        }
    },
    created() {
        this.namespace = utils.namespace('ui-dialog', false);
    },
    mounted() {
        document.body.appendChild(this.$el);
    },
    methods: {
        click(btn, data) {
            if (this.hasCheckbox) {
                data.checked = this.checked;
            }
            this.$emit('click', btn, data);
        }
    }
};
</script>

<style lang="scss">
@import '../../mds/constants';
$namespace: 'markets-ui-dialog';
.#{$namespace} {
    overflow-y: auto;
    &-title {
        font-weight: bold;
    }
    &-single-mode {
        justify-content: center;
    }
    &-checkbox {
        margin-top: 10px;
    }
    &-container--dark-gray {
        .#{$namespace}-active {
            color: $mds-background-color-light-gray;
            background: $mds-color-neutral-12;
        }
    }
}
</style>
